module.exports = __webpack_public_path__ + "1792395595471/images/ondato-logo.189e1d5.svg";